/**
 * StaffUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffUpdateReq
 */
export interface StaffUpdateReq {
  /** 员工ID */
  id?: string
  /** 用户名 */
  username?: string
  /** 昵称 */
  nickname?: string
  /** 简介 */
  bio?: string
  /** 是否禁用 */
  disabled?: boolean
  /** 是否超级管理员 */
  is_super_admin?: boolean
}

/**
 * StaffUpdateReq Schema
 */
export const StaffUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '员工ID',
      format: 'string',
      type: 'string',
      label: '员工ID',
    },
    username: {
      description: '用户名',
      format: '*string',
      maxLength: 20,
      minLength: 3,
      type: 'string',
      label: '用户名',
    },
    nickname: {
      description: '昵称',
      format: '*string',
      type: 'string',
      label: '昵称',
    },
    bio: {
      description: '简介',
      format: '*string',
      type: 'string',
      label: '简介',
    },
    disabled: {
      description: '是否禁用',
      format: '*bool',
      type: 'boolean',
      label: '是否禁用',
    },
    is_super_admin: {
      description: '是否超级管理员',
      format: '*bool',
      type: 'boolean',
      label: '是否超级管理员',
    },
  },
  type: 'object',
}
